export default __webpack_public_path__ + "static/niche@992-877d28443487281cfe79621b393afce0.png";